export class EmptySearchParamsFilterModel {
}
